/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunnelmutuals3Inputs */

const en_liveroomfunnelmutuals3 = /** @type {(inputs: Liveroomfunnelmutuals3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi back`)
};

const de_liveroomfunnelmutuals3 = /** @type {(inputs: Liveroomfunnelmutuals3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi zurück`)
};

/**
* | output |
* | --- |
* | "Hi back" |
*
* @param {Liveroomfunnelmutuals3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunnelmutuals3 = /** @type {((inputs?: Liveroomfunnelmutuals3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunnelmutuals3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunnelmutuals3(inputs)
	return de_liveroomfunnelmutuals3(inputs)
});
export { liveroomfunnelmutuals3 as "liveRoomFunnelMutuals" }